import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Button } from '@/shared/uikitV2/Button';

export const ButtonDestructiveText = styled(Button)`
  &&& {
    background: none;
    color: ${COLORS.systemFlame200};
    padding: 0;
    &:hover {
      background: none !important;
      color: ${COLORS.systemFlame300} !important;
    }
  }
`;
